module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_a-function.js
// module id = 10
// module chunks = 0